import type { CreateKeldaConfigDto, KeldaConfigDto } from '../dto/keldaConfigDto';
import type { ApiCommand, ApiRequest } from './apiCommand';
import { assumeArray, assumeObject } from '../type-guards/assumeType';

export class ListKeldasCommand implements ApiCommand<KeldaConfigDto[]> {
  constructor(input: Record<string, never>) {
    void input;
  }

  request(): ApiRequest {
    return {
      linkName: 'configs',
      pathParams: {
        type: 'kelda'
      },
      queryParams: {},
      method: 'GET',
      body: null
    };
  }

  asOutput(body: unknown): KeldaConfigDto[] {
    return assumeArray<KeldaConfigDto>(body);
  }
}

export class GetKeldaCommand implements ApiCommand<KeldaConfigDto> {
  constructor(private input: { configId: string }) {
  }

  request(): ApiRequest {
    return {
      linkName: 'config',
      pathParams: {
        type: 'kelda',
        configId: this.input.configId
      },
      queryParams: {},
      method: 'GET',
      body: null
    };
  }

  asOutput(body: unknown): KeldaConfigDto {
    return assumeObject<KeldaConfigDto>(body, 'indexedFolders');
  }
}

export class CreateKeldaCommand implements ApiCommand<void> {
  constructor(private input: { config: CreateKeldaConfigDto }) {
  }

  request(): ApiRequest {
    return {
      linkName: 'configs',
      pathParams: {
        type: 'kelda',
      },
      queryParams: {},
      method: 'POST',
      body: this.input.config
    };
  }

  asOutput(body: unknown): KeldaConfigDto {
    return assumeObject<KeldaConfigDto>(body, 'indexedFolders');
  }
}

export class DeleteKeldaCommand implements ApiCommand<void> {
  constructor(private input: { configId: string }) {
  }

  request(): ApiRequest {
    return {
      linkName: 'config',
      pathParams: {
        type: 'kelda',
        configId: this.input.configId
      },
      queryParams: {},
      method: 'DELETE',
      body: null
    };
  }

  asOutput(body: unknown): void {
  }
}
